/**
 * Link List block — accordion triggers
 * Guarded init so multiple block instances on one page each bind once.
 */
export function initLinkList() {
    document.querySelectorAll('.block-link-list:not([data-link-list-init])').forEach((block) => {
        block.dataset.linkListInit = 'true';

        block.querySelectorAll('.block-link-list__trigger').forEach((btn) => {
            btn.addEventListener('click', () => {
                const item = btn.closest('.block-link-list__item');
                if (!item) return;

                const isOpen = item.classList.contains('is-open');

                if (!isOpen) {
                    item.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                } else {
                    item.classList.remove('is-open');
                    btn.setAttribute('aria-expanded', 'false');
                }
            });
        });
    });
}
